$(document).ready(function () {

  function changePage(hash) {
    if(hash !== undefined) {
      $('a[href="' + hash + '"]').tab('show')
    }
  }

  changePage(location.hash);

  $('a[data-toggle="tab"]').on('show.bs.tab', function (e) {
    location.hash = $(e.target).attr('href');
    setTimeout(function() {window.scrollTo(0, 0);}, 1);
  });

  function formatInstrument(item) {
    if (!item.id) {
      return item.text;
    }
    const type = item.id.split("-")[0];
    return $('<span class="instruments-text">' + item.text + "</span>");
  }

  $(".select2-instruments").select2({
    templateResult: formatInstrument,
    width: "100%",
  });

  $("#user-finance").on("click", () => {
    if (window && window.location && window.location.pathname) {
      if (!window.location.pathname.includes("/user/finance")) {
        window.location.pathname = "/user/finance";
      }
    }
  });

  $(".user-finance").on("click", () => {
    if (window && window.location && window.location.pathname) {
      if (!window.location.pathname.includes("/user/finance")) {
        window.location.pathname = "/user/finance";
      }
    }
  });

  $(".small-amount").hide();
  $(".method-type").removeClass("text-danger");

  $("input, select").focus(function () {
    $(".small-amount").hide();
    $(".method-type").removeClass("text-danger");
  });

  $(".crosspay-select").on("click", function () {
    var isChecked = $(this).prop("checked");

    if (!isChecked) {
      //$("input[type=text]").prop('disabled', 'disabled');
      $(".methods").attr("disabled", "disabled");
    } else {
      $(".methods").removeAttr("disabled");
    }
  });

  $(".payout-amount").each(function () {
    $(this).inputmask({
      alias: "numeric",
      allowMinus: false,
      digits: 2,
      min: 1,
    });
  });

  let submitPayout = function (currencyTitle) {
    $.ajax({
      url: "/ajax/getWithdrawConfirmationModalWindow",
      type: "POST",
      data: {
        YII_CSRF_TOKEN: token,
        balance: currencyTitle,
        'payout-method': $("#methods-" + currencyTitle).val(),
        'payout-amount': $("#amount-" + currencyTitle).val(),
      },
    }).done(function (response) {
      response = JSON.parse(response);
      if (response.code == 0) {
        let $modal = $(response.modal || "#payoutNotificationModal");
        $modal.find("#payout-body").html(response.response.modal_html);
        let rates = response.response.rates;
        if (!$.isEmptyObject(rates)) {
          let $payoutForm = ($(`#payout-form-${currencyTitle}`));
          let $withdrawButton = $modal.find('.withdraw');

          $.each(rates, function(key, value) {
            if (Object.keys(rates).length === 1 && value === 1) {
              $withdrawButton.data('the-same-rate', true);
            }
            else {
              $withdrawButton.data('the-same-rate', false);
              let $rateInput = $payoutForm.find(`input[name="rates[${key}]"]`);
              if ($rateInput.length) {
                $rateInput.val(value);
              }
              else {
                let input = `<input type="hidden" name="rates[${key}]" value="${value}" />`;
                $payoutForm.append(input);
              }
            }
          });
        }

        $("#payout-notification-submit-button").attr(
          "data-balance",
          currencyTitle
        );
        const inputs = $("input[type=radio][name=final-currency]");
        if (inputs.length > 1) {
          $("#payout-notification-submit-button").attr("disabled", false);
        } else if (inputs.length === 1) {
          const currencyItem = $(
            "input[type=radio][name=final-currency]"
          ).filter(":first");
          $("#payout-currency-" + currencyItem.data("balance-id")).val(
            currencyItem.val()
          );
          $("#payout-notification-submit-button").attr("disabled", false);
        } else {
          $("#payout-notification-submit-button").attr("disabled", true);
        }
        $modal.modal();
      } else if (response.code === 104 && response.response.error) {
        $(`#payout-form-${currencyTitle} #amount-error-message-hidden`).text(
            response.response.error
        );
      }
    });
  };

  $("body").on("change", "input[type=radio][name=final-currency]", function () {
    $("#payout-currency-" + $(this).data("balance-id")).val($(this).val());
    $("#payout-notification-submit-button").attr("disabled", false);

    let currentCurrency = $("input[name='final-currency']:checked").val();

    let $commissionInfoBlocks = $('.modal-commission-group-window');

    for (let i = 0; i < $commissionInfoBlocks.length; i++) {
      let $infoBlock = $($commissionInfoBlocks[i]);
      let currency = $infoBlock.data('currencyCommission');

      if (currency === currentCurrency) {
        $infoBlock.removeClass('hidden');
      } else {
        $infoBlock.addClass('hidden');
      }
    }
  });

  function checkMethod(currencyCode) {
    let element = $('select[id^="methods-' + currencyCode + '"]');
    let button = $($("button[data-balance=" + currencyCode + "]").get(0));
    if (!!element.get(0).value && element.get(0).value !== "0") {
      $("#method-error-message-" + currencyCode).css("visibility", "hidden");
      button.prop("disabled", false);
      element.css("border-color", "");
      return true;
    } else {
      $("#method-error-message-" + currencyCode).css("visibility", "visible");
      button.prop("disabled", true);
      element.css("border-color", "var(--danger)");
      return false;
    }
  }

  function checkAmount(currencyCode) {
    let element = $('input[id^="amount-' + currencyCode + '"]');
    let maxValue = element.attr("max");
    let button = $($("button[data-balance=" + currencyCode + "]").get(0));

    if (
      element.get(0).value &&
      parseFloat(element.get(0).value) > parseFloat(maxValue)
    ) {
      $("#amount-error-message-" + currencyCode).css("visibility", "visible");
      button.prop("disabled", true);
      element.css("border-color", "var(--danger)");
      return false;
    } else {
      $("#amount-error-message-" + currencyCode).css("visibility", "hidden");
      button.prop("disabled", false);
      element.css("border-color", "");
      return true;
    }
  }

  $('select[id^="autopay-method-"]').on("change", function () {
    let element = $(this);
    let currencyCode = element.attr("data-balance");
    if (element.val()) {
      $(`#autopay-submit-${currencyCode}`).attr("disabled", false);
    } else {
      $(`#autopay-submit-${currencyCode}`).attr("disabled", true);
    }
  });

  $('input[id^="autopay-checkbox-"]').on("change", function () {
    let element = $(this);
    let currencyCode = element.attr("data-balance");
    if (!element[0].checked) {
      $(`#autopay-submit-${currencyCode}`).attr("disabled", false);
    }
  });

  $('select[id^="methods-"]').on("change", function () {
    let element = $(this);
    let currencyCode = element.attr("data-balance");
    checkMethod(currencyCode);
  });

  $('input[id^="amount-"]').on("keyup", function () {
    let element = $(this);
    let currencyCode = element.attr("data-balance");
    checkAmount(currencyCode);
  });

  $(".payout-form").on("click mousedown keydown", function () {
    $(this).submit(false);
  });

  $(".payout-money").on("click", function () {

    let $modalMainContent = $('#modal-main-content');
    let $modalContentInProgress = $('#modal-content-in-progress');
    $modalContentInProgress.css('display', 'none');
    $modalMainContent.css('display', 'block');

    const currencyCode = $(this).data("balance");
    if (checkAmount(currencyCode) && checkMethod(currencyCode)) {
      submitPayout(currencyCode);
    }
  });

  $(".withdraw").on("click", function () {
    let $withdrawBtn = $(this);

    if ($withdrawBtn.hasClass("clicked")) {
      return;
    }

    let theSameRate = $withdrawBtn.data('the-same-rate');
    let balance = $withdrawBtn.data('balance');
    let $payoutForm = document.getElementById(`payout-form-${balance}`);
    let $modalMainContent = $('#modal-main-content');
    let $modalMainContentHeader = $modalMainContent.find('.modal-header');
    let $modalContentInProgress = $('#modal-content-in-progress');
    let $modalContentInProgressBody = $modalContentInProgress.find('.modal-body');
    let resultHeight = $modalMainContent.outerHeight() - $modalMainContentHeader.outerHeight();
    $modalContentInProgressBody.css({
      'height': resultHeight,
      'line-height': resultHeight + 'px',
    });
    $modalMainContent.css('display', 'none');
    $modalContentInProgress.css('display', 'block');

    if (theSameRate) {
      let selectedCurrency = $('input[name="final-currency"]:checked').val();
      const inputElement = document.createElement('input');
      inputElement.setAttribute('name', 'payout-currency');
      inputElement.setAttribute('type', 'hidden');
      inputElement.setAttribute('value', selectedCurrency);
      $payoutForm.appendChild(inputElement);
      $payoutForm.submit();
      return;
    }

    let formData = new FormData($payoutForm);
    let selectedCurrency = $('input[name="final-currency"]:checked').val();
    let balanceCurrency = $('input[name="balanceCurrency"]').val();
    formData.append('selected-currency', selectedCurrency);
    formData.append('balance', balanceCurrency)

    let $selectedCurrencyLabel = $(`label[for="option-${selectedCurrency}"]`)
    let $errorHeader = $('#payoutNotificationModal #payoutModalLabel');
    $.ajax({
      url: '/ajax/isCurrencyRateProfitable',
      data: formData,
      processData: false,
      contentType: false,
      type: 'POST',
      success: function (response) {
        response = JSON.parse(response);
        if (response.response.error) {
          $errorHeader.text(response.response.error);
          $selectedCurrencyLabel.text(response.response.label_text);
          let rate = response.response.rate;
          let $rateInput = $(`#payout-form-${balance} input[name="rates[${rate.currency_name}]"]`);
          $rateInput.val(rate.currency_rate);
          $modalContentInProgress.css('display', 'none');
          $modalMainContent.css('display', 'block');
          return false;
        }
        $withdrawBtn.find(".fa-refresh").show();
        $withdrawBtn.addClass("clicked");
        const inputElement = document.createElement('input');
        inputElement.setAttribute('name', 'payout-currency');
        inputElement.setAttribute('type', 'hidden');
        inputElement.setAttribute('value', selectedCurrency);
        $payoutForm.appendChild(inputElement);
        $payoutForm.submit();
        },
      error: function () {
        $errorHeader.text(translate.currencyRateIsProfitableError);
        return false;
      }
    });

  });

  $("#statisticsExport").click(function () {
    $("#statisticsExportModal").modal();
  });

  $("#disable-bank-131").click(function () {
    let $button = $(this);

    if ($button.hasClass("clicked")) {
      return;
    }

    $button.find(".fa-refresh").show();
    $button.addClass("clicked");

    $.ajax({
      url: '/ajax/disableBank131',
      type: "POST",
      data: {
        YII_CSRF_TOKEN: token,
      },
    }).done(function (response) {
      response = JSON.parse(response);
      if (response.code == 0) {
        location.reload();
      }
    });
  });

  $('.payout-method').on('change', function () {
    let $this = $(this),
        jwtToken = localStorage.getItem('accessToken'),
        balanceId = $this.data('balance-id'),
        payoutEndpointId = $this.find(':selected').data('payout-endpoint-id'),
        payoutEndpointType = $this.find(':selected').data('payout-endpoint-type'),
        amount = $('.payout-amount').val();

    $.ajax({
      url: '/api/finance/calculate-payout',
      type: 'GET',
      data: {
        balanceId: balanceId,
        amount: amount,
        payoutEndpointId: payoutEndpointId,
        payoutEndpointType: payoutEndpointType
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + jwtToken
      },
      success: () => {
        $('.finance-next-step-info .text-danger').text('');
        $('.finance-next-step-info .text-black').show();
      },
      error: (response) => {
        if (response.responseJSON.error !== undefined && response.responseJSON.code === 29) {
          $('.finance-next-step-info .text-black').hide();
          $('.finance-next-step-info .text-danger').text(response.responseJSON.error);
        }
      }
    });
  });
});
